/**
 * ログイン用パスキー（/login のボタン・/account の「ログイン用パスキー」・再認証の「パスキーで確認」）の英語（2026-09-28 creator/passkey-login）。
 * en.ts が `...enLoginPasskey` で取り込む（ja.loginPasskey.ts が同じキーを全部持つことを型で強制）。
 *
 * 言葉の決め事: 出金用のパスキー（Money の画面・pk.*）と取り違えないよう、こちらは必ず「sign-in passkey / ログイン用パスキー」と書く。
 *   2 つは別の登録で、互いに使えない（サーバーの loginPasskeys.ts の冒頭）。本人が「パスキーを足したのに出金できない / ログインできない」
 *   と迷わないよう、見出しと説明の両方で違いを書く（指示書 2）。
 */
export const enLoginPasskey = {
  'auth.passkeyUnavailable': 'Passkey sign-in is not available right now. Sign in another way.',

  'reauth.passkey': 'Confirm with a passkey',
  'reauth.passkeyNote': 'Use one of your sign-in passkeys (Face ID, Touch ID, Windows Hello or a security key).',
  'reauth.passkeyFailed': 'Could not confirm with a passkey. Try again or use another way.',

  'lpk.title': 'Sign-in passkeys',
  'lpk.lead': 'Sign in with your face, fingerprint or screen lock on your computer or phone, without typing your email or password (Face ID, Touch ID, Windows Hello or a security key).',
  'lpk.separate': 'These are separate from the passkeys that confirm withdrawals. A sign-in passkey cannot confirm a withdrawal, and a withdrawal passkey cannot sign you in.',
  'lpk.moneyLink': 'Withdrawal passkeys (Money → Passkeys)',
  'lpk.empty': 'No sign-in passkeys yet.',
  'lpk.add': 'Add a sign-in passkey',
  'lpk.addTitle': 'Add a sign-in passkey',
  'lpk.label': 'Name',
  'lpk.labelPlaceholder': 'e.g. MacBook, iPhone',
  'lpk.create': 'Create passkey',
  'lpk.addHint': 'You will confirm it is you first, then your device will ask you to create the passkey.',
  'lpk.reauthResumed': 'We checked that it is you. Press “Create passkey” again to create it.',
  'lpk.added': 'Sign-in passkey added. You can now sign in with it.',
  'lpk.removed': 'Sign-in passkey removed. Just in case, the dashboard on your other devices, and any AI agent or terminal command you connected, were signed out (sign in again to use them).',
  'lpk.remove': 'Remove',
  'lpk.removeTitle': 'Remove “{label}”?',
  'lpk.removeBody': 'You will no longer be able to sign in with this passkey. It also stays on your device until you delete it there.',
  'lpk.lastNote': 'This is your only way to sign in, so it cannot be removed. Set a password or add another sign-in method first.',
  'lpk.neverUsed': 'not used yet',
  'lpk.cancelled': 'The passkey prompt was closed. Nothing was added.',
  'lpk.alreadyOnDevice': 'This device already has a sign-in passkey for this account.',
  'lpk.unsupported': "This browser can't use passkeys. Try a recent Chrome, Safari, Edge or Firefox.",
  'lpk.unavailable': 'Sign-in passkeys cannot be added right now. Sign in another way, such as your email and password.',
  'lpk.max': 'You have the maximum of {max} sign-in passkeys. Remove one to add another.',
  'lpk.lost': 'Lost your device? Sign in another way, or use “Forgot password?” on the sign-in page.'
};
